const ChartMixin = {
  props: {
    chartConfig: {
      type: Object,
      default: function() {
        return {}
      }
    },
    renderSence: {
      type: String,
      default: function () {
        return 'render'
      }
    }
  },
  data() {
    return {
      legendData: [],
      dimension: []
    }
  },
  computed: {
    guidelines() {
      return this.chartConfig && this.chartConfig.guidelines ? this.chartConfig.guidelines : []
    },
    yList() {
      return this.chartConfig && this.chartConfig.reportYAxisList
        ? this.chartConfig.reportYAxisList
        : []
    },
    parseDimension() {
      if (this.chartConfig &&
        this.chartConfig.reportXAxesList &&
        this.chartConfig.reportXAxesList.length > 0 &&
        this.chartConfig.reportXAxesList[0].groupType !== 'DATA_VALUE') {
        if (this.chartConfig.reportXAxesList[0].groupType === 'WEEK') {
          return this.dimension.map(item => this.getWeekStr(item))
        } else if (this.chartConfig.reportXAxesList[0].groupType === 'DAY') {
          return this.dimension.map(item => this.getDayStr(item))
        } else if (this.chartConfig.reportXAxesList[0].groupType === 'MONTH') {
          return this.dimension.map(item => this.getMonthStr(item))
        } else if (this.chartConfig.reportXAxesList[0].groupType === 'QUARTER') {
          return this.dimension.map(item => this.getQuarterStr(item))
        } else if (this.chartConfig.reportXAxesList[0].groupType === 'YEAR') {
          return this.dimension.map(item => this.getYearStr(item))
        }
        return this.dimension
      }
      return this.dimension
    }
  },
  mounted() {
    window.addEventListener('resize', this.resizeTheChart)
    this.$nextTick(() => {
      this.resizeTheChart()
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeTheChart)
  },
  methods: {
    getWeekStr(str) {
      let strs = str.split('-')
      return strs[0] + '年' + strs[1] + '周'
    },
    getYearStr(str) {
      return str + '年'
    },
    getMonthStr(str) {
      let strs = str.split('-')
      return strs[0] + '年' + strs[1] + '月'
    },
    getDayStr(str) {
      let strs = str.split('-')
      return strs[0] + '年' + strs[1] + '月' + strs[2] + '日'
    },
    getQuarterStr(str) {
      let strs = str.split('-')
      return strs[0] + '年' + strs[1] + '季度'
    },
    formatterMarkLine(guidelineName, params) {
      return guidelineName + ' ' + params.value
    },
    handleLoadingDone() {
      this.resizeTheChart()
    },
    getMaxY(yMax) {
      let max = yMax
      this.guidelines.forEach((item) => {
        if (max < parseFloat(item.guidelineValue)) {
          // 这一步是因为坐标高度的精确度有限，辅助线过于精确时可能会出现辅助线与坐标高度等值
          // 却超出坐标高度不显示的问题，因此将坐标高度设定为辅助线高度向上取整
          max = Math.ceil(parseFloat(item.guidelineValue))
        }
      })
      return max
    },
    xAxisFormatter(value, index) {
      // todo: 完善
      // const columnWidth = (this.$refs.chart.$el.offsetWidth - 60) / this.dimension.length
      const parentColumnWidth = (this.$el.offsetWidth - 60) / this.dimension.length
      const barWidth = this.legendData.length * 24
      const columnWidth = Math.max(parentColumnWidth, 60, barWidth) - 10
      const length = parseInt(columnWidth / 12.5)
      if (value.length > length) {
        return value.slice(0, length) + '...'
      } else {
        return value
      }
    },
    renderData() {
      let tempData = []
      let itemExist = false
      this.dimension = this.data.map((item) => item.xaxisField)
      this.data.forEach((ele) => {
        ele.yaxisValues.forEach((one) => {
          if (one.item) {
            itemExist = true
          }
        })
      })
      if (itemExist) {
        this.data.forEach((ele) => {
          ele.yaxisValues.forEach((one) => {
            if (tempData.filter((key) => key === one.item).length < 1) {
              tempData.push(one.item)
            }
          })
        })
      } else {
        this.data.forEach((ele) => {
          ele.yaxisValues.forEach((one) => {
            if (tempData.filter((key) => key.c === one.componentId).length < 1) {
              // let com = this.chartConfig.reportYAxisList.filter(com => com.componentId === one.componentId)
              // let label = com.length > 0 ? com[0].label : ' '
              tempData.push({
                c: one.componentId,
                l: one.label
              })
            }
          })
        })
      }
      if (tempData.length < 1) {
        tempData.push('')
      }
      this.legendData = tempData.map((item) => {
        let list = []
        this.data.map((one) => {
          if (one.yaxisValues.filter((yv) => (yv.item === item || (item && yv.componentId === item.c))).length > 0) {
            list.push(parseFloat(one.yaxisValues.filter((yv) => yv.item === item || (item && yv.componentId === item.c))[0].value))
          } else if (!itemExist && one.yaxisValues && one.yaxisValues.length === 1 && !one.yaxisValues[0].item) {
            list.push(parseFloat(one.yaxisValues[0].value))
          } else {
            list.push(0)
          }
        })
        return {
          name: itemExist ? (item || ' ') : item.l,
          value: list,
          component: item
        }
      })
    },
    reRender() {
      this.resizeTheChart()
    },
    resizeTheChart() {
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.$refs.chart) {
            if (
              this.$options.name === 'Bar' &&
              this.legendData &&
              this.dimension
            ) {
              const totalWidth = this.legendData.length * this.dimension.length * 24 + 60
              const columnWidth = this.dimension.length * 60 + 60
              const parentWidth = this.$el.offsetWidth
              this.$refs.chart.$el.style.width = Math.max(totalWidth, columnWidth, parentWidth) / 14 + 'rem'
            } else if (
              this.$options.name === 'LineChart' &&
              this.dimension
            ) {
              if (this.dimension.length * 60 + 60 > this.$el.offsetWidth) {
                this.$refs.chart.$el.style.width = (this.dimension.length * 60 + 60) / 14 + 'rem'
              } else {
                this.$refs.chart.$el.style.width = '100%'
              }
            } else {
              this.$refs.chart.$el.style.width = '100%'
            }
            this.$refs.chart.resize()
          }
        }, 10)
      })
    },
    refresh() {
      this.queryData()
      this.queryGuideLines()
    }
  }
}

export default ChartMixin
